module.exports = __webpack_public_path__ + "media/images/icons/material/check-circle-1772dbe95636eae3805db87a535087da.svg";